import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../store/authSlice";
import { getCurrentUser } from "../api/authAPI";

function OAuthCallback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const finalizeOAuth = async () => {
      try {
        const res = await getCurrentUser();
        if (res.success && res.data) {
          // Set Redux state
          dispatch(setUser(res.data));

          // Remove # from URL for clean redirect
          window.history.replaceState(null, null, window.location.pathname);

          // Redirect to home
          navigate("/");
        } else {
          navigate("/login"); // fallback if session failed
        }
      } catch (err) {
        console.error("OAuth Callback Error:", err);
        navigate("/login");
      }
    };

    finalizeOAuth();
  }, [dispatch, navigate]);

  return (
    <div className="flex items-center justify-center h-screen w-screen bg-gradient-to-br from-purple-500 via-indigo-600 to-blue-500">
      <div className="text-center">
        <div className="mb-6">
          <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
          Signing you in...
        </h1>
        <p className="text-white/80">
          Please wait while we securely log you in.
        </p>
      </div>
    </div>
  );
}

export default OAuthCallback;
